/**
 * Logo definitivo de Nexus Creative (Dirección, 2026-07-21).
 *
 * Cuatro nodos y sus enlaces dibujan una N: es un grafo, no una letra decorada
 * — la marca dice lo que el sistema hace. El nodo central, macizo, es el punto
 * de decisión: todo pasa por ahí.
 *
 * 🔑 Va EN LÍNEA y no como `<img src="logo.svg">` a propósito. Un `<img>` no
 * puede heredar `currentColor`: el archivo se pinta con su color por defecto y
 * el logo salía negro sobre el riel azul. En línea, el color lo pone
 * `--ds-marca` y la identidad queda en un solo lugar — cambiar el color de
 * marca no obliga a reexportar el logo.
 */
export function LogoNexus({ size = 64 }: { size?: number }) {
  const id = 'nc-glow';
  return (
    <svg
      className="ds-rail__logo"
      width={size} height={size} viewBox="0 0 120 120"
      role="img" aria-label="Nexus Creative"
      style={{ color: 'var(--ds-marca-hi)' }}
    >
      <defs>
        <filter id={id} x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="3.5" result="b" />
          <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
        </filter>
      </defs>

      <g fill="none" stroke="currentColor" strokeWidth={7}
         strokeLinecap="round" filter={`url(#${id})`}>
        {/* Los tres trazos de la N: montante izquierdo, diagonal, montante derecho */}
        <path d="M26 26 V94" />
        <path d="M26 26 L94 94" />
        <path d="M94 26 V94" />

        {/* Los cuatro nodos, huecos. El relleno toma el fondo del riel para que
            el trazo no se vea cruzar por dentro del círculo. */}
        <circle cx="26" cy="26" r="12" fill="var(--ds-rail)" />
        <circle cx="94" cy="26" r="12" fill="var(--ds-rail)" />
        <circle cx="26" cy="94" r="12" fill="var(--ds-rail)" />
        <circle cx="94" cy="94" r="12" fill="var(--ds-rail)" />
      </g>

      {/* El nodo de decisión: macizo, en el cruce de la diagonal */}
      <rect x="49" y="49" width="22" height="22" rx="4"
            transform="rotate(45 60 60)" fill="currentColor" filter={`url(#${id})`} />
    </svg>
  );
}
